import React from 'react';
import PropTypes from 'prop-types';

import { useAuth } from 'utils/auth';
import getDisplayName from 'utils/getDisplayName';
import { actions } from 'utils/permissions';

function WithPermission(WrappedComponent) {
    const _withPermissionHoc = (props) => {
        const auth = useAuth();

        const { needPermission } = props || {};

        if (needPermission && Object.keys(actions).includes(needPermission)) {
            const hasPermission = auth.hasPermission(needPermission);

            if (!hasPermission) {
                return null;
            }
        }

        return <WrappedComponent {...props} />;
    };

    _withPermissionHoc.propTypes = {
        ...WrappedComponent.propTypes,
        needPermission: PropTypes.string,
    };

    _withPermissionHoc.displayName = `WithPermission(${getDisplayName(WrappedComponent)})`;

    return _withPermissionHoc;
}

export default WithPermission;
